import React from 'react';
import { Redirect } from 'react-router-dom';
import { usePermissionsContext } from 'modules/Common/permissions/PermissionsProvider';
import PermissionsErrorState from 'modules/Common/permissions/PermissionsErrorState';
import CgPageLoader from 'modules/Common/layout/CgPageLoader';
import { SupplierEntitlement } from './planAccess';
import SupplierApp from './app/routes';

// OI-10 — one portal studio per operator.
//
// `/supplier/share` + `/supplier/embed` are mounted for EVERY Operator org, not
// just free-tier ones, because portal management had to survive a free
// supplier upgrading (the canonical CbamPortal keeps their slug, password,
// colour and revision consent). Once the operator portal became a studio of its
// own at `/public-catalog`, that left a paying operator with TWO authoring UIs
// over the same record — the free-tier one in the Lite shell and their own in
// the app shell.
//
// So: keep the routes for orgs on the free-tier Journey entitlement, and send
// everyone else to the operator studio. Both write the same CbamPortal, so this
// is purely which shell you author in — nothing is lost by redirecting, and an
// upgraded supplier's settings are all still there under `/public-catalog`.
//
// A redirect (not the shared EntitlementGuard) because this is a RE-HOMING,
// not a denial: the operator is entitled to portal management, just not to
// THIS shell, and `/public-catalog` is a page they may genuinely use. A denial
// would render in place instead (see EntitlementGuard, and
// docs/features/denial-never-navigates/00-OVERVIEW.md N1). The `status`
// guards below are what keep this from firing on an unresolved plan.
export default function SharePortalRouteGate(props) {
  const { status, hasEntitlement } = usePermissionsContext();

  // Never decide on an unresolved plan — redirecting here would bounce a free
  // supplier out of their own studio on a slow /permissions/me.
  if (status === 'loading') return <CgPageLoader />;
  if (status === 'error') return <PermissionsErrorState />;
  if (!hasEntitlement(SupplierEntitlement.Journey)) return <Redirect to="/public-catalog" />;

  return <SupplierApp {...props} />;
}
